import React, { useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { getEndTrialAddCardUrl } from "api/hiredrateURLConstruct";
import { ERROR } from "store/constant";
import { useNotification } from "store/context/Notification";
// import HDConfirmationDialog from "ui-component/confirm-dialog/HDConfirmationDialog";
import CheckoutBackdrop from "ui-component/loader/CheckoutBackdrop";
import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HDConfirmationDialog from "ui-component/dialog/HDConfirmationDialog";
import AppConfig from "api/AppConfig";

const ManageSubscription = () => {
  const { companyID } = useSelector((state) => state.account);
  const { showNotification } = useNotification();
  const theme = useTheme();

  const [loading, setLoading] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showBackdrop, setShowBackdrop] = useState(false);
  const configObject = AppConfig("APIConfig");


  // Show confirmation dialog when user clicks "End Trial"
  const handleEndTrialClick = () => {
    setShowConfirmDialog(true);
  };

  // Handle confirmation and redirect
  const handleConfirmEndTrial = async () => {
    try {
      setShowConfirmDialog(false);
      setShowBackdrop(true);
      setLoading(true);

      const payload = {
        company_id: companyID,
        redirect_url:
          `${window.location.origin}/settings/subscription/manage-subscription-result`,
        cancel_url:
          `${window.location.origin}/settings/subscription/manage-subscription-result?cancelled=true`,
      };

      const response = await axios.post(
        getEndTrialAddCardUrl(),
        payload,
        configObject
      );

      if (response.data?.checkout_url) {
        window.location.href = response.data.checkout_url;
      } else {
        setShowBackdrop(false);
        setLoading(false);
      }
    } catch (error) {
      const message =
        error?.response?.data?.detail || error?.message || "Something went wrong";

      showNotification(ERROR, message, ERROR, "Subscription");
      setShowBackdrop(false);
      setLoading(false);
    }
  };

  // Handle cancel
  const handleCancelEndTrial = () => {
    setShowConfirmDialog(false);
  };

  return (
    <>
      {/* Confirmation Dialog */}
      <HDConfirmationDialog
        open={showConfirmDialog}
        onClose={handleCancelEndTrial}
        onConfirm={handleConfirmEndTrial}
        title="End Trial & Add Payment Method"
        message="You are about to end your trial period and add a payment method to continue with your subscription. You will be redirected to Chargebee to complete the process."
        confirmButtonText="Proceed to Payment"
        cancelButtonText="Cancel"
        loading={loading}
      >
        <Box sx={{
          mt: 2,
          p: 2,
          bgcolor: theme.palette.grey[50],
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`
        }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            What happens next:
          </Typography>
          <Box sx={{ mt: 1 }}>
            <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              • Your trial period will end
            </Typography>
            <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              • You will be asked to add a payment method
            </Typography>
            <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              • Your subscription will continue with the selected plan
            </Typography>
            <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              • You will be redirected to Chargebee's secure payment page
            </Typography>
          </Box>

          <Box sx={{
            mt: 2,
            p: 1.5,
            bgcolor: theme.palette.warning.light + '20',
            borderRadius: 1,
            border: `1px solid ${theme.palette.warning.light}`
          }}>
            <Typography variant="body2" color="text.secondary" fontSize="0.85rem">
              You will be redirected to Chargebee's secure payment page to add your payment method.
            </Typography>
          </Box>
        </Box>
      </HDConfirmationDialog>

      {/* Backdrop for loading state */}
      <CheckoutBackdrop
        open={showBackdrop}
        title="Redirecting to payment page..."
        description="Please wait while we prepare your secure checkout session."
        selectedItem="End Trial & Add Payment Method"
        selectedItemLabel="Action"
        redirectText="Redirecting to Chargebee..."
        providerName="Chargebee"
      />

      <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", width: "100%" }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Manage Subscription
        </Typography>

        <Button
          onClick={handleEndTrialClick}
          disabled={loading}
          variant="contained"
          sx={{
            padding: "10px 20px",
            background: theme.palette.primary.main,
            color: "#fff",
            borderRadius: "6px",
            textTransform: "none",
            fontWeight: 600,
            '&:hover': {
              background: theme.palette.primary.dark,
            },
            '&.Mui-disabled': {
              background: theme.palette.grey[400],
              color: theme.palette.grey[600],
            }
          }}
        >
          {loading ? "Redirecting..." : "End Trial & Add Payment Method"}
        </Button>
      </Box>
    </>
  );
};

export default ManageSubscription;